export default function Vedio(props) {
  return (
    <>
      <iframe
        title="vedio"
        src={"https://www.tiktok.com/embed/" + props.linkVedio}
        allowfullscreen
        scrolling="no"
        allow="encrypted-media;"
        height="580px"
        frameborder="none"
      ></iframe>
    </>
  );
}
/*
7253542322535664901
7244525612830967301
*/